import React, { memo } from "react";
import { TableGridProps } from "./types";
import { Loader } from "ui/components/Loader";
import NoResults from "../../NoResults/NoResults";
import { TableGridBody, TableGridFooter } from "./components";

const TableGrid = <T extends { id: string }>(props: TableGridProps<T>) => {
  const {
    data,
    renderItem,
    pagination,
    onPaginationChange,
    isLoading,
    selectedItems,
    onSelectedChange,
    selectableItems = false,
  } = props;

  if (!isLoading && pagination?.totalPages === 0) {
    return <NoResults />;
  }

  return (
    <div className="flex flex-col relative">
      {/* Grid */}
      <TableGridBody
        data={data}
        renderItem={renderItem}
        selectableItems={selectableItems}
        selectedItems={selectedItems}
        onSelectedChange={onSelectedChange}
      />

      {/* Footer with controls and pagination */}
      <TableGridFooter
        pagination={pagination}
        onPaginationChange={onPaginationChange}
      />

      <Loader isLoading={isLoading ?? false}> </Loader>
    </div>
  );
};

export default memo(TableGrid) as typeof TableGrid;
